import { getPCConsoleStatConfig } from './pcConsoleStat';
import { getPCConsoleSteamOverlapConfig } from './pcConsoleSteamOverlap';
import { getPCConsoleAmpereOverlapConfig } from './pcConsoleAmpereOverlap';
import { getMobileTopChartsRPDConfig } from './mobileTopChartsRPD';
import { getTrueAllDataDownloadExcel } from './trueAllDataDownloadExcel';
import { getMarketProfileTopChartsCombineConfig } from './marketProfileTopChartsCombineConfig';
import { getMobileTopChartsMultiDataSourceConfig } from './mobileTopChartsMultiDataSource';
import { getMobileOverlapTopChartsConfig } from './mobileOverlapTopCharts';
import { getMobileOverlapDetailsConfig } from './mobileOverlapDetails';
import { getCombineStatsAllMetricsConfig } from './combineStatsAllMetrics';
import { getCombineStatsSteamDataConfig } from './combineStatsSteamData';
import { getCasualGenreProfileConfig } from './casualGenreProfile';
import { getMarketProfileStatsConfig } from './marketProfileStatsNew';
import { getWeixinStoreRankMoreConfig } from './weixinStoreRankMore';
import { getCasualCompetitorsKeyGamesConfig } from './casualCompetitorsKeyGames';
import { getMinigameDetailsStoreRankConfig } from './minigameDetailsStoreRank';
import { getCasualCompetitorsTopPublishersConfig } from './casualCompetitorsTopPublishers';
import { getAlineaAnalyticsCalibrationPCConsoleTopChartsConfig } from './alineaAnalyticsCalibrationPCConsoleTopCharts';
import { getRobloxGameRankConfig } from './robloxGameRank';
import { getRobloxTopChartsConfig } from './robloxTopCharts';

export const downloadConfig = {
  pc_console_kpi_trends: getPCConsoleStatConfig,
  pc_console_steam_overlap: getPCConsoleSteamOverlapConfig,
  pc_console_ampere_overlap: getPCConsoleAmpereOverlapConfig,
  mobile_topCharts_RPD: getMobileTopChartsRPDConfig,
  trueAllDataDownloadExcel: getTrueAllDataDownloadExcel,
  marketProfileTopChartsCombine: getMarketProfileTopChartsCombineConfig,
  mobileTopChartsMultiDataSource: getMobileTopChartsMultiDataSourceConfig,
  mobileOverlapTopCharts: getMobileOverlapTopChartsConfig,
  mobileOverlapDetails: getMobileOverlapDetailsConfig,
  combineStatsAllMetrics: getCombineStatsAllMetricsConfig,
  combineStatsSteamData: getCombineStatsSteamDataConfig,
  casualGenreProfile: getCasualGenreProfileConfig,
  marketProfileStatsNew: getMarketProfileStatsConfig,
  weixinStoreRankMore: getWeixinStoreRankMoreConfig,
  minigameDetailsStoreRank: getMinigameDetailsStoreRankConfig,
  casualCompetitorsKeyGames: getCasualCompetitorsKeyGamesConfig,
  casualCompetitorsTopPublishers: getCasualCompetitorsTopPublishersConfig,
  alineaAnalyticsCalibrationPCConsoleTopCharts: getAlineaAnalyticsCalibrationPCConsoleTopChartsConfig,
  robloxGameRank: getRobloxGameRankConfig,
  robloxTopCharts: getRobloxTopChartsConfig,
} as any;
